<template>
  <div class="i_body">
    <div class="i_top">
      <div class="img">
        <img :src="info.headportrait ? info.headportrait : avator" alt="" />
      </div>
      <div class="name">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ info.username }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :style="{
                color: userid == i.id ? '#fff' : '',
                background: userid == i.id ? 'rgba(74, 138, 216, 0.5)' : ''
              }"
              v-for="i in stuDetailList"
              :key="i.id"
              :command="i.id"
              >{{ i.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <!-- <span>{{ info.username }}</span> -->
      </div>
      <div
        style="position: absolute;top: 35%;left: 0;"
        @click="upStu"
        v-if="num"
      >
        <el-tooltip content="上一个" placement="top" effect="dark">
          <i
            class="el-icon-arrow-left"
            style="font-size: 25px;cursor: pointer;"
          ></i>
        </el-tooltip>
      </div>
      <div
        style="position: absolute;top: 35%;right: 0;"
        @click="nextStu"
        v-if="num != stuList.length - 1"
      >
        <el-tooltip content="下一个" placement="top" effect="dark">
          <i
            class="el-icon-arrow-right"
            style="font-size: 25px;cursor: pointer;"
          ></i>
        </el-tooltip>
      </div>
    </div>
    <div class="i_bottom">
      <div class="i_bottom_span">
        <span style="text-align: left;">班级</span>
        <el-tooltip
          :content="info.cname ? info.cname : '暂无'"
          placement="top"
          effect="dark"
        >
          <span>{{ info.cname ? info.cname : "暂无" }}</span>
        </el-tooltip>
      </div>
      <div class="i_bottom_span">
        <span style="text-align: left;">备注</span>
        <el-tooltip
          :content="info.intro ? info.intro : '暂无'"
          placement="top"
          effect="dark"
        >
          <span>{{ info.intro ? info.intro : "暂无" }}</span>
        </el-tooltip>
      </div>
      <div class="i_bottom_btn" @click="openInfo()">
        <span class="edit"></span>
        <span>编辑个人信息</span>
      </div>
    </div>
    <infoDialog
      :dialogVisibleInfo.sync="dialogVisibleInfo"
      :userid="userid"
      :oid="oid"
    ></infoDialog>
  </div>
</template>

<script>
// import { backgroundClip } from "html2canvas/dist/types/css/property-descriptors/background-clip";
import avator from "../../../../assets/icon/test/teacher.jpg";
import infoDialog from "./infoDialog/index.vue";
export default {
  components: {
    infoDialog
  },
  props: {
    userid: {
      type: String
    },
    teaId: {
      type: String
    },
    oid: {
      type: String
    },
    cid: {
      type: String
    },
    org: {
      type: String
    },
    role: {
      type: String
    }
  },
  data() {
    return {
      avator: avator,
      info: {},
      dialogVisibleInfo: false,
      // 班级学生列表
      stuList: [],
      stuDetailList: [],
      // 处在班级的第几个位置
      num: ""
    };
  },
  watch: {
    dialogVisibleInfo(newValue, oldValue) {
      this.getData();
    }
  },
  methods: {
    upStu() {
      this.num = this.num * 1 - 1;
      this.$emit("updateUid", this.stuList[this.num]);
    },
    nextStu() {
      this.num = this.num * 1 + 1;
      this.$emit("updateUid", this.stuList[this.num]);
    },
    handleCommand(e) {
      // this.$message("click on item " + command);
      this.$emit("updateUid", e);
    },

    // 下拉框切换学生
    cutStu(e) {
      // console.log("钓到没", e);
      this.$emit("updateUid", e.id);
    },
    // 获取班学生列表
    getStuList() {
      this.stuList = [];
      const data2 = {
        cid: this.cid
      };

      this.ajax
        .get(this.$store.state.api + "selectClassStudent", data2)
        .then(res => {
          // console.log(res.data[0]);
          let data = res.data[0];
          data.forEach(e => {
            this.stuList.push(e.id);
          });
          data.forEach(e => {
            let a = { id: "", name: "" };
            (a.id = e.id), (a.name = e.name);
            this.stuDetailList.push(a);
          });

          this.num = this.stuList.indexOf(this.userid);
          // console.log("获取班学生列表", this.stuDetailList);
        })
        .catch(err => {
          console.error(err);
        });

      // selectClassStudent(data2).then(res => {
      //   res[0].forEach(e => {
      //     this.stuList.push(e.id);
      //   });
      //   // console.log('获取班学生列表', this.stuList)
      //   // 查询学生在数组中的位置
      //   this.num = this.stuList.indexOf(this.userid);
      //   console.log('oooooo', this.stuList, this.num);
      // });
    },
    getData() {
      let params = {
        uid: this.userid
      };
      this.ajax
        .get(this.$store.state.api + "selectSDetail", params)
        .then(res => {
          this.info = res.data[0][0];
          // console.log("this.info ", this.info);
          // 用于存储归类后的数据的对象
        })
        .catch(err => {
          console.error(err);
        });
    },
    openInfo() {
      this.dialogVisibleInfo = true;
    }
  },
  mounted() {
    this.getData();
    this.getStuList();
  }
};
</script>

<style scoped>
.i_body {
  width: 100%;
  min-height: auto;
  height: calc(40% - 10px);
  background: #fff;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 15px;
}

.i_top {
  height: 55%;
  width: calc(100% - 20px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 10px 0px 0px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #efefef;
  position: relative;
}

.i_top > .img {
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 50%;
}

.i_top > .img > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.i_top > .name {
  width: 100%;
  margin: 10px;
  text-align: center;
}

.i_top > .name >>> .el-dropdown {
  max-width: 100%;
  font-size: 22px;
  font-weight: 700;
  cursor: pointer;
  overflow: hidden;
  color: black;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* .i_top > .name >>> .popper__arrow {
  left: 70px !important;
} */
.el-dropdown-menu {
  width: 190px;
  left: 45px !important;
  height: 180px;
  overflow: auto;
}
.el-icon--right {
  font-size: 20px;
}
.el-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}
.el-dropdown-menu::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #b9b9b9;
}
.el-dropdown-menu::-webkit-scrollbar-track {
  border-radius: 8px;
  background: #e4e4e4;
}
.el-dropdown-menu::-webkit-scrollbar-button {
  display: none;
}
/* .i_top > .name >>> .el-dropdown-menu__item {
  text-align: center;
}  */
.i_bottom {
  height: 45%;
  width: calc(100% - 20px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.i_bottom > .i_bottom_span {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  font-size: 15px;
}

.i_bottom > .i_bottom_span + .i_bottom_span {
  margin-top: 10px;
}

.i_bottom > .i_bottom_span > span:nth-child(1) {
  width: 50px;
  min-width: 50px;
  text-align: right;
  color: #a1a1a1;
}

.i_bottom > .i_bottom_span > span:nth-child(2) {
  width: calc(100% - 30px);
  overflow: hidden;
  /* margin-left: 20px; */
  white-space: nowrap;
  text-overflow: ellipsis;
}

.i_bottom > .i_bottom_btn {
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #dbdbdb;
  box-sizing: border-box;
  width: 90%;
  background: rgb(252, 252, 252);
  margin: 30px auto 0;
  height: 35px;
  font-weight: 600;
  font-size: 12px;
  display: flex;

  align-items: center;
  justify-content: center;
}

.i_bottom > .i_bottom_btn > .edit {
  display: block;
  width: 15px;
  height: 15px;
  background-size: 100% 100%;
  background-image: url("../../../../assets/icon/test/edit-icon.png");
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kindStudentEva/info/index.vue